import type { Locale } from '@/types'

export const COMMON_COUNTRIES = ['DE', 'AT', 'CH', 'FR', 'BE', 'NL', 'LU', 'IT', 'GB', 'TN', 'DZ', 'LY', 'MA', 'US', 'CA']

const ALL_CODES = 'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CD CF CG CH CI CK CL CM CN CO CR CU CV CW CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'

export const COUNTRY_CODES: Array<string> = ALL_CODES.split(' ')

const displayNames = new Map<string, Intl.DisplayNames>()

export const countryName = (code: string | null | undefined, locale: Locale = 'de'): string => {
    if (!code) return ''

    const upper = code.toUpperCase()

    if (!/^[A-Z]{2}$/.test(upper)) return code

    try {
        let names = displayNames.get(locale)

        if (!names) {
            names = new Intl.DisplayNames([locale], { type: 'region' })
            displayNames.set(locale, names)
        }

        return names.of(upper) ?? upper
    }
    catch {
        return upper
    }
}

export const isCountryCode = (value: string): boolean => COUNTRY_CODES.includes(value.toUpperCase())

export const sortedCountries = (locale: Locale): Array<{ code: string, name: string }> => {
    const collator = new Intl.Collator(locale)

    return COUNTRY_CODES
        .map(code => ({ code, name: countryName(code, locale) }))
        .sort((a, b) => collator.compare(a.name, b.name))
}
